import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DpspData from "../data/dedicatedProxmoxServerPlans.json";

const DpspPage = () => {
  const [pageData, setPageData] = useState({});
    useEffect(() => {
        if (DpspData?.Dpsp?.length > 0) {
        setPageData(DpspData.Dpsp[0]);
        }
    }, []);
    if (!pageData) return <p>Loading...</p>;

  return (
    <>
        <div className="page-title">
          <div className="container py-5">
            <h2 className="title position-relative">{pageData.title}</h2>
          </div>
        </div>

        <section className="product-section vps-hosting">
          <div className="container">
            <div className="row">
                <div className="col">
                    <div className="section-title text-center">
                        <h2>{pageData.subTitle}</h2>
                    </div>
                </div>
            </div>

            <div className="row">
                {pageData?.Plans?.length > 0 &&
                    pageData.Plans.map((product, idc) => (
              <div key={idc} className="col-lg-3 col-md-6 col-sm-6 my-5">
                <div className="product-card">
                    <div className="clean-pricing-item">
                        
                        {/* <div className="ribbon"><span>{product.ribbon}</span></div> */}

                        <table className="table table-bordered pricing-table text-center">
                            <thead>
                                    <tr>
                                    <td><h4>{product.title}</h4><span className="price">{product.price}</span> /mo.<br />{product.setup}<br /><a className="text-light btn btn-custom btn-lg" href={product.order_link}>Order Now</a></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {product.features.map((feature, i) => (
                                        <tr key={i}>
                                        <td>{feature}</td>
                                        </tr>
                                    ))}
                                </tbody>
 
                        </table>

                    </div>
                </div>
              </div>
              ))}
              {/*colend*/}
            </div>

            <div className="row">
              <div className="col">
                <div className="txt-wrap pb-3">
                    <div class="section-title">
                      <h4 className="mb-3"><i class="fa fa-shield"></i>&nbsp;Security Features (Included in All Plans)</h4>
                    <ul className="product-features">
                      <li><i class="fa fa-check"></i>&nbsp;Proxmox VE 8.x LTS pre-installed</li>
                      <li><i class="fa fa-check"></i>&nbsp;pfSense firewall with dynamic IP or DynDNS-based access</li>
                      <li><i class="fa fa-check"></i>&nbsp;Only ports 22 (SSH) and 8006 (Proxmox UI) are open</li>
                      <li><i class="fa fa-check"></i>&nbsp;All other traffic blocked by default</li>
                      <li><i class="fa fa-check"></i>&nbsp;Access limited to your submitted IP or DNS record</li>
                    </ul>
                    </div>
                </div>
              </div>
            </div>

          </div>
        </section>

    </>
  );
};

export default DpspPage;
